import React, { ReactNode, useState } from "react";

import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import { useAppSelector } from "../../../hooks/hooks";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import ResponsiveModalAbsolute from "../../../components/ResponsiveModalAbsolute";
import dividirFechaDatePicker from "../../../helpers/dividirFechaDatePicker";
import { InputDate } from "../../../components/InputDate";
import { useParams } from "react-router-dom";

interface Descuento {
    descuento: string;
    dia_final: number;
    dia_inicio: number;
    fecha_final: string;
    fecha_inicio: string;
    id: number;
    id_casa?: number;
    id_habitacion?: number;
    tipo: string;
}

interface Input {
    id_casa?: number | null;
    id_habitacion?: number | null;
    rango_inicio: string;
    rango_final: string;
    precio: string;
    tipo: string;
    fecha_inicio: string;
    fecha_final: string;
}

interface ModalProps {
    modalVisible: boolean;
    setModalVisible: (visible: boolean) => void;
    descuentoSelect: Descuento;
    setDescuentoSelect: (s: Descuento | null) => void;
}

export const ModalEditDiscount = ({
    modalVisible,
    setModalVisible,
    descuentoSelect,
    setDescuentoSelect,
}: ModalProps) => {
    registerLocale("es", es);
    const { idCasa } = useParams();

    const { tipo_usuario } = useAppSelector((state) => state.usuario_logeado);
    const { id: id_casa, tipo_moneda } = useAppSelector(
        (state) => state.landing_house.house
    );

    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState<Input>({
        id_casa: id_casa,
        id_habitacion: idCasa ? Number(idCasa) : null,
        rango_inicio: `${descuentoSelect.dia_inicio}`,
        rango_final: `${descuentoSelect.dia_final}`,
        precio: descuentoSelect.descuento,
        tipo: descuentoSelect.tipo,
        fecha_inicio:
            descuentoSelect.tipo === "Siempre"
                ? ""
                : descuentoSelect.fecha_inicio,
        fecha_final:
            descuentoSelect.tipo === "Siempre"
                ? ""
                : descuentoSelect.fecha_final,
    });

    const handleSubmit = async () => {
        if (input.precio === "") {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Error",
                text: "Debes agregar un monto a descontar ",
                icon: "error",
                confirmButtonText: "Ok",
            });

            return;
        }

        if (input.rango_inicio === "" || input.rango_final === "") {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Error",
                text: "Debes agregar la cantidad de dias (Desde y Hasta) ",
                icon: "error",
                confirmButtonText: "Ok",
            });

            return;
        }

        if (
            input.tipo === "Fecha" &&
            (input.fecha_inicio === "" || input.fecha_final === "")
        ) {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Error",
                text: "Debes agregar el rango de fechas",
                icon: "error",
                confirmButtonText: "Ok",
            });

            return;
        }

        try {
            setLoading(true);

            if (
                tipo_usuario === 3 ||
                tipo_usuario === 4 ||
                tipo_usuario === 6
            ) {
                await fetchAxiosToken({
                    url: `/descuentos_tiempos/put/${descuentoSelect.id}`,
                    body: {
                        ...input,
                        dia_inicio: Number(input.rango_inicio),
                        dia_final: Number(input.rango_final),
                        descuento: input.precio,
                    },
                    method: "put",
                });
            }

            if (tipo_usuario === 8) {
                await fetchAxiosToken({
                    url: `/descuentos_tiempos_habitaciones/put/${descuentoSelect.id}`,
                    body: {
                        ...input,
                        dia_inicio: Number(input.rango_inicio),
                        dia_final: Number(input.rango_final),
                        descuento: input.precio,
                    },
                    method: "put",
                });
            }

            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Actualizado con exito",

                icon: "success",
                confirmButtonText: "Ok",
            });
            setDescuentoSelect(null);

            setLoading(false);
        } catch (error: any) {
            console.log(error);
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Error",
                text: `${error.response.data.error}`,
                icon: "error",
                confirmButtonText: "Ok",
            });
            setLoading(false);
        }
    };

    return (
        <ResponsiveModalAbsolute
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
        >
            <h1 className="2xl:text-lg text-base font-medium text-center">
                Editar descuento por estadia
            </h1>
            <div className="flex flex-col max-w-md gap-4 p-4 mx-auto ">
                <div className="flex flex-col items-center justify-center">
                    <div className="w-full">
                        <label className="2xl:text-lg text-base font-medium ">
                            Por:
                        </label>
                        <select
                            name="tipo_estadia"
                            onChange={(e) =>
                                setInput({
                                    ...input,
                                    tipo: e.target.value,
                                })
                            }
                            className="w-8/12 ml-2  pl-1 xs:px-4 rounded-lg 2xl:py-2 py-1.5 2xl:text-base text-sm bg-transparent border border-[#E9E9E9] outline-none focus:outline-none placeholder:text-gray-400 cursor-pointer"
                            value={input.tipo}
                        >
                            <option value="Siempre">Siempre</option>
                            <option value="Fecha">Fecha</option>
                        </select>
                    </div>

                    {input.tipo === "Fecha" && (
                        <>
                            <hr className="w-full my-4 bg-gray-300" />
                            <div className="w-full">
                                <h2 className="2xl:text-base text-sm font-medium text-left">
                                    Fechas
                                </h2>
                                <div className="flex items-center w-full mt-2">
                                    <label className="2xl:text-lg text-sm font-medium ">
                                        Inicial:
                                    </label>

                                    <InputDate
                                        className="w-8/12 p-2 ml-6 bg-white border rounded-lg cursor-pointer 2xl:py-2 py-1.5 2xl:text-base text-sm"
                                        selectedDay={input.fecha_inicio}
                                        placeholderText="Seleccionar fecha"
                                        onChange={(date) =>
                                            setInput({
                                                ...input,
                                                fecha_inicio: date ? date : "",
                                            })
                                        }
                                    />
                                </div>
                                <div className="flex items-center w-full mt-2">
                                    <label className="mr-2 2xl:text-lg text-base font-medium">
                                        Final:
                                    </label>

                                    <InputDate
                                        className="w-8/12 p-2 ml-6 bg-white border rounded-lg cursor-pointer 2xl:py-2 py-1.5 2xl:text-base text-sm"
                                        selectedDay={input.fecha_final}
                                        placeholderText="Seleccionar fecha"
                                        onChange={(date) =>
                                            setInput({
                                                ...input,
                                                fecha_final: date ? date : "",
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    <hr className="w-full my-4 bg-gray-300" />
                    <div className="w-full">
                        <h2 className="2xl:text-base text-sm font-medium text-left">
                            Cantidad de dias
                        </h2>
                        <div className="flex items-center w-full mt-2">
                            <label className="2xl:text-lg text-base font-medium ">
                                Desde:
                            </label>
                            <input
                                type="number"
                                placeholder="Dias"
                                onChange={(e) =>
                                    setInput({
                                        ...input,
                                        rango_inicio: e.target.value,
                                    })
                                }
                                className=" w-20 xs:w-24 ml-2 pl-[1px]  xs:px-2 rounded-lg 2xl:py-2 py-1.5 2xl:text-base text-sm bg-transparent border border-[#E9E9E9] outline-none focus:outline-none placeholder:text-gray-400"
                                value={input.rango_inicio}
                            />
                            <label className="ml-2 2xl:text-lg text-base font-medium ">
                                Hasta:
                            </label>
                            <input
                                type="number"
                                placeholder="Dias"
                                onChange={(e) =>
                                    setInput({
                                        ...input,
                                        rango_final: e.target.value,
                                    })
                                }
                                className="  w-20 xs:w-24 ml-2 pl-[1px] xs:px-2 rounded-lg 2xl:py-2 py-1.5 2xl:text-base text-sm bg-transparent border border-[#E9E9E9] outline-none focus:outline-none placeholder:text-gray-400"
                                value={input.rango_final}
                            />
                        </div>
                    </div>

                    <hr className="w-full my-4 bg-gray-300" />
                    <div className="w-full">
                        <h2 className="2xl:text-base text-sm font-medium text-left">
                            Descuento
                        </h2>
                        <div className="items-center w-full mt-2 xs:flex">
                            <label className="font-medium ">
                                Descuento total({tipo_moneda}):
                            </label>
                            <input
                                type="number"
                                placeholder="50"
                                onChange={(e) =>
                                    setInput({
                                        ...input,
                                        precio: e.target.value,
                                    })
                                }
                                className=" w-8/12 xs:w-24 mt-1 xs:ml-2 px-2 rounded-lg 2xl:py-2 py-1.5 2xl:text-base text-sm bg-transparent border border-[#E9E9E9] outline-none focus:outline-none placeholder:text-gray-400"
                                value={input.precio}
                            />
                        </div>
                    </div>
                </div>

                <button
                    disabled={loading}
                    onClick={() => handleSubmit()}
                    className="p-3 mt-6 font-medium text-white border rounded-lg bg-[#029BFC] active:translate-y-1 disabled:translate-y-0 disabled:from-slate-400 disabled:to-gray-400 disabled:cursor-default 2xl:text-base text-sm"
                >
                    Actualizar descuento por estadia
                </button>
            </div>
        </ResponsiveModalAbsolute>
    );
};
